import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';
import { TabelaPreco } from '../tabela-preco';

@Injectable({
    providedIn: 'root'
})
export class TabelaPrecoDuplicateHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/tabelapreco`;
    }

    /** Duplica a tabela de preço informada para uma nova tabela de preço */
    duplicate(id: number): Observable<TabelaPreco> {
        return this.customHttp.put<TabelaPreco>(`${this.pathApi}/${id}/duplicate`, null);
    }
}
